function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('../../../dgs/dgs-api'); // eslint-disable-line helix/no-restricted-dependency
require('../../../dgs/dgs-events'); // eslint-disable-line helix/no-restricted-dependency
require('./polyfill/wdh-nodelist-foreach');

/**
 * WDH Utility API
 *
 */
var WDH = /*#__PURE__*/function () {
  function WDH() {
    _classCallCheck(this, WDH);
  }
  return _createClass(WDH, null, [{
    key: "resolveTemplate",
    value: function resolveTemplate(html, options) {
      // Inspired by http://krasimirtsonev.com/blog/article/Javascript-template-engine-in-just-20-line
      var re = /{([^}]+)?}/g;
      var match;
      var output = html;
      while (match = re.exec(output)) {
        output = output.replace(match[0], options[match[1]]);
      }
      return output;
    }
  }, {
    key: "getAll",
    value: function getAll(selector, parent) {
      var target = parent || document;
      var elements = target.querySelectorAll(selector);
      return Array.prototype.slice.call(elements);
    }
  }]);
}();
var onLoad = window.DGS.OnLoad.getInstance().register;
var onResize = window.DGS.Resizer.getInstance().register;
var triggerResize = window.DGS.Resizer.getInstance().execute;
var onScroll = window.DGS.Scroller.getInstance().register;
var isMobileDevice = window.DGS.UserAgent.getInstance().mobileTabletCheck;
var resolveTemplate = WDH.resolveTemplate,
  getAll = WDH.getAll;
var triggerEvent = window.DGS.Event.getInstance().trigger;
var clearEvent = window.DGS.Event.getInstance().off;
var onEvent = window.DGS.Event.getInstance().on;
export { onLoad, onScroll, onResize, triggerResize, getAll, isMobileDevice, resolveTemplate, triggerEvent, clearEvent, onEvent };